import { getApiEndpoint } from "../utils/constants/api";
import { wfetch } from "../utils/fetch";

// Delivery HTML-escapes string properties ("→&quot;), so productRef arrives escaped.
// Decode entities before JSON.parse (a no-op for already-clean values).
const decodeEntities = (s) => {
    if (typeof s !== "string") return s;
    if (typeof document === "undefined") {
        return s.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
    }
    const t = document.createElement("textarea");
    t.innerHTML = s;
    return t.value;
};

// The picker stores the decorated product as a JSON ref { source, productId } in `productRef`.
const parseRef = (raw) => {
    if (!raw || typeof raw !== "string") return null;
    try {
        return JSON.parse(decodeEntities(raw));
    } catch (e) {
        return null;
    }
};

// A product decoration enriches a product (from any source) with a 3D/AR model, an extra
// description and additional images. It's authored in the optional feature-product-decorations
// module and identified by the product's source + productId, which we read out of the stored
// picker ref (`productRef`) — no separate flattened properties needed. Resolves to null when the
// module (and thus the endpoint) isn't deployed, so the storefront degrades without a hard
// dependency. The decoration set is small (hand-curated), so fetching all and matching client-side
// is fine and keeps the authoring form to a single picker field.
export const getProductDecoration = async ({ source, productId }) => {
    if (!source || !productId) return null;
    try {
        const res = await wfetch(getApiEndpoint("PRODUCT_DECORATION"));
        const results = res?.data?.results || [];
        return (
            results.find((n) => {
                const ref = parseRef(n.productRef);
                return ref && ref.source === source && (ref.productId || ref.id) === productId;
            }) || null
        );
    } catch (e) {
        return null;
    }
};
